<p-panel
  [attr.id]="isTopLevelSection ? 'section-' + field.id : null"
  [dt]="props?.dt?.components?.panel"
  [toggleable]="true"
  [collapsed]="!props.first && !props.expandedByDefault"
  toggler="header"
  [toggleButtonProps]="{
    ariaLabel: props.label,
  }"
  [attr.data-testid]="testId"
  [class.hidden]="props.hideIfNoTabs && allTabsHidden"
  rememberState
  [rememberStateGroupKey]="props.rememberStateGroupKey || 'default'"
  [rememberStateKey]="props.rememberStateKey || props.label"
>
  <ng-template #header>
    <div class="flex flex-1 items-center">
      <div class="col">
        <span
          class="p-panel-title"
          [class.section-header]="isTopLevelSection"
          [class.text-xl]="isTopLevelSection"
          [class.font-bold]="isTopLevelSection"
          [class.text-danger]="invalid$ | async"
          [class.text-highlight]="suggested$ | async"
          [class.text-ai-fill]="filledByAI$ | async"
        >
          {{ props.label }}
          @if (showDebugInfo) {
            @if (formErrorsTooltip(); as tooltip) {
              <i class="pi pi-info-circle ms-1 text-sm cursor-help" [pTooltip]="tooltip" [escape]="false" tooltipPosition="right"></i>
            }
          }
        </span>

        @if (props.description) {
          <span class="text-body-text-regular text-text-caption">
            {{ props.description }}
          </span>
        }
      </div>

      @if (!props.readonly && !props.hideUnsavedChanges) {
        @if (unsavedChanges$ | async; as unsavedChanges) {
          <p-tag
            [dt]="props.dt?.components?.tag"
            class="flex-none ms-auto"
            severity="info"
            [rounded]="true"
            [value]="unsavedChanges"
          />
        }
      }
    </div>
  </ng-template>

  @for (field of field.fieldGroup; track field) {
    @if (!field.hide) {
      <formly-field [field]="field" />
    }
  }
</p-panel>
